import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';
import { IconSizesEnum, IIcon } from 'i2g-ng-ui';
import { PricingDataStore } from '../../../pricing-data/pricing-data.store';
import {
  OfferCtaTypesEnum,
  OfferTypesEnum,
} from '../../../pricing-data/pricing-data.data';
import { BehaviorSubject, Observable } from 'rxjs';
import { NavigationService } from '../../../navigation/navigation.service';
import { PricingOffer } from '../../../pricing-data/models/pricing-offer.model';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import { OfferTrackingObject } from '../../../tracking/models/objects/offer-tracking-object.model';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';

export const DIALOG_TYPE = 'cancel-subscription-offer-dialog';

@Component({
  selector: 'app-cancel-subscription-offer-dialog',
  templateUrl: './cancel-subscription-offer-dialog.component.html',
  styleUrls: ['./cancel-subscription-offer-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CancelSubscriptionOfferDialogComponent implements OnInit {
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @Output() ctaClick: EventEmitter<void> = new EventEmitter<void>();

  loadingSpinnerIcon: IIcon;
  trackingObject: OfferTrackingObject;

  dialogType: string;
  offer$: Observable<PricingOffer | boolean>;
  offerCtaTypeEnum: typeof OfferCtaTypesEnum;
  imageLoadingComplete$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  constructor(
    private _pricingDataStore: PricingDataStore,
    private _navigationService: NavigationService,
    private _trackingObjectBuilder: TrackingObjectBuilder,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;
    this.loadingSpinnerIcon = {
      name: 'i2g-loader',
      size: IconSizesEnum.x_large,
    };
    this.offerCtaTypeEnum = OfferCtaTypesEnum;
    this.trackingObject = this._trackingObjectBuilder.buildOffer(
      OfferTypesEnum.cancellation_winback
    );

    this.offer$ = this._pricingDataStore.getOfferByType(
      OfferTypesEnum.cancellation_winback
    );
  }

  onImageLoad() {
    this.imageLoadingComplete$.next(true);
  }

  // identifier comes from backend
  buildButtonTappedTrackingAction(ctaType: OfferCtaTypesEnum) {
    const buttonIdentifier =
      ctaType === OfferCtaTypesEnum.primary ? 'accept' : 'cancel';
    return this._trackingActionBuilder.buildButtonTapped(
      buttonIdentifier,
      this.trackingScreenName
    );
  }

  handleDeeplink(deeplink: string) {
    this._navigationService.goToDeepLink(deeplink);

    this.ctaClick.emit();
  }
}
